import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SERVICE_PILLARS } from '../../data/servicePillars';
import './MainNav.css';

const MainNav = ({ darkMode, toggleDarkMode }) => {
  const [openMobile, setOpenMobile] = useState(false);

  useEffect(() => {
    const closeMobile = (e) => {
      if (!e.target.closest('.main-nav') && openMobile) {
        setOpenMobile(false);
      }
    };

    if (openMobile) {
      document.addEventListener('mousedown', closeMobile);
    }

    return () => {
      document.removeEventListener('mousedown', closeMobile);
    };
  }, [openMobile]);

  const closeMobileMenu = () => {
    setOpenMobile(false);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleNavClick = () => {
    closeMobileMenu();
    scrollToTop();
  };

  return (
    <nav className={`main-nav${darkMode ? ' dark' : ''}`}>
      <Link to="/" className="logo" onClick={handleNavClick}>
        <span className="logo-wordmark" aria-label="E-ASY">
          <span className="logo-wordmark-prefix">E-</span>
          <span className="logo-wordmark-main">ASY</span>
        </span>
      </Link>
      <button
        type="button"
        className="nav-hamburger"
        onClick={() => setOpenMobile(!openMobile)}
        aria-label="Abrir menú"
      >
        <span />
        <span />
        <span />
      </button>
      <ul className={`nav-links${openMobile ? ' open' : ''}`}>
        <li className="nav-item">
          <Link to="/" className="nav-link" onClick={handleNavClick}>
            Inicio
          </Link>
        </li>
        <li className="nav-item has-mega">
          <Link to="/servicios" className="nav-link" onClick={handleNavClick}>
            Servicios
          </Link>
          <div className="nav-dropdown" role="menu" aria-label="Pilares de servicio">
            {SERVICE_PILLARS.map((pilar) => (
              <Link
                key={pilar.id}
                to={pilar.href}
                className="nav-dropdown-link"
                role="menuitem"
                onClick={handleNavClick}
              >
                <span className="nav-dropdown-title">{pilar.title}</span>
                <span className="nav-dropdown-desc">{pilar.navDesc}</span>
              </Link>
            ))}
          </div>
        </li>
        <li className="nav-item">
          <Link to="/capacidades" className="nav-link" onClick={handleNavClick}>
            Capacidades
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/sectores" className="nav-link" onClick={handleNavClick}>
            Sectores
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/sobre-nosotros" className="nav-link" onClick={handleNavClick}>
            Sobre nosotros
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/blog" className="nav-link" onClick={handleNavClick}>
            Blog
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/contacto" className="nav-link" onClick={handleNavClick}>
            Contacto
          </Link>
        </li>
        <li className="nav-item">
          <button type="button" className="toggle-mode" onClick={toggleDarkMode}>
            {darkMode ? 'Modo claro' : 'Modo oscuro'}
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default MainNav;
